import * as React from 'react'
import { DownTime, DowntimePropertyName } from '../../../model/DownTime'
import ValidationMessageList from '../ValidationMessageList'
import { LockStatus } from '../../../model/DownTimeEnums'

type Props = {
  downtime: DownTime
  penalisingStatus: string[]
  updateDowntime: (downtime: DownTime) => void
}

export class PenalisingStatusCell extends React.Component<Props> {
  public render(): JSX.Element {
    const { downtime, penalisingStatus, updateDowntime } = this.props
    if (downtime.lockStatus === LockStatus.notLocked) {
      return (
        <div>
          <select
            value={downtime.penalisingStatus}
            onChange={e => {
              updateDowntime(new DownTime({ ...downtime, penalisingStatus: e.target.value }))
            }}
            className="form-control"
          >
            {penalisingStatus &&
              penalisingStatus.map(status => (
                <option value={status} key={status}>
                  {status}
                </option>
              ))}
          </select>
          <ValidationMessageList
            property={DowntimePropertyName.PenalisingStatus}
            downtime={downtime}
          />
        </div>
      )
    } else {
      return (
        <div>
          <p>{downtime.penalisingStatus}</p>
          <ValidationMessageList
            property={DowntimePropertyName.PenalisingStatus}
            downtime={downtime}
          />
        </div>
      )
    }
  }
}

export default PenalisingStatusCell
